import UrlPattern from 'url-pattern';

const getPath = (path) => path.replace(/\((.*)\)/, '$1?');

const options = {
    segmentNameCharset: 'a-zA-Z0-9_',
    segmentValueCharset: 'a-zA-Z0-9-_~ %+=',
};

const createRoute = (path) => {
    const route = new UrlPattern(path, options);
    route.path = getPath(path);
    
    return route;
};

export const login = createRoute('/login');
export const signin = createRoute('/signin');
export const email_verification = createRoute('/email_verification');
export const password_recovery = createRoute('/password_recovery');
export const password_reset = createRoute('/password_reset/:token');
export const promo = createRoute('/:page(/:token)');
export const products = createRoute('/products')
export const main = createRoute('/');
export const profile = createRoute('/profile');
export const bonus = createRoute('/bonus');
export const projects = createRoute('/projects');
export const project_show = createRoute('/projects/:id');
export const project_add = createRoute('/projects/add');
export const project_edit = createRoute('/projects/:id/edit');
export const project_application_add = createRoute('/projects/:project_id/application/add/:region_name');
export const project_application = createRoute('/projects/:project_id/application/:id');
export const project_application_edit = createRoute('/projects/:project_id/application/:id/edit');
export const configurator = {
    catalog: createRoute('/configurator/catalog(/:id)'),
    design: createRoute('/configurator/design'),
    frame: {
        //createRoute('/configurator/frame')
        path: 'https://legrand.ru/for_designers/products/elektroustanovochnye-izdeliya'
    }
};
export const notifications = createRoute('/notifications');



// WEBPACK FOOTER //
// ./src/constants/routes.js